import { render } from "./AddVideoModal.vue?vue&type=template&id=219a25e1"
import script from "./AddVideoModal.vue?vue&type=script&lang=js"
export * from "./AddVideoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__